import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
const routes = [
  {
    path: '/',
    redirect: flag instanceof Array ? '/mb_home' : "/home",
  },
  {
    path: '/home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: 'PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_home',
    component: () => import('@/views/Mobile/home.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
    meta: {
      title: 'ABOUT US | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_about',
    component: () => import('@/views/Mobile/aboutUs.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('@/views/TechnologyView.vue'),
    meta: {
      title: 'TECHNOLOGY | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_technology',
    component: () => import('@/views/Mobile/technology.vue'),
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/ContactsView.vue'),
    meta: {
      title: 'CONTACTS | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_contacts',
    component: () => import('@/views/Mobile/contacts.vue'),
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/platformView.vue'),
    meta: {
      title: 'PLATFORM | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_platform',
    component: () => import('@/views/Mobile/platform.vue'),
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/serviceView.vue'),
    meta: {
      title: 'SERVICES | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/populariz',
    name: 'populariz',
    component: () => import('@/views/popularizeView.vue'),
    meta: {
      title: 'POPULARIZ | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_populariz',
    component: () => import('@/views/Mobile/populariz.vue'),
  },
  {
    path: '/expansion',
    name: 'expansion',
    component: () => import('@/views/expansionView.vue'),
    meta: {
      title: 'EXPANSION | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_expansion',
    component: () => import('@/views/Mobile/expansion.vue'),
  },
  {
    path: '/material',
    name: 'material',
    component: () => import('@/views/materialView.vue'),
    meta: {
      title: 'MATERIAL | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_material',
    component: () => import('@/views/Mobile/material.vue'),
  },
  {
    path: '/flow',
    name: 'flow',
    component: () => import('@/views/flowView.vue'),
    meta: {
      title: 'FLOW | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_flow',
    component: () => import('@/views/Mobile/flow.vue'),
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('@/views/businessView.vue'),
    meta: {
      title: 'BUSINESS | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_business',
    component: () => import('@/views/Mobile/business.vue'),
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/RegistrationView.vue'),
    meta: {
      title: 'REGISTRATION | PHARM OPTIMA | 万良诚科 '
    }
  },
  {
    path: '/mb_registration',
    component: () => import('@/views/Mobile/registration.vue'),
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
